const baseURL = 'https://turnos.komerzy.com/';

export default baseURL;
